const calendarViewModes = {
  Month: 1,
  Week: 2,
  Day: 3,
};

export default calendarViewModes;
